// extracted by mini-css-extract-plugin
module.exports = {"container":"DurationInput_container__YWJhC","label":"DurationInput_label__R5vtC","input":"DurationInput_input__Kuyf5","select":"DurationInput_select__yus4t"};